import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';

const {
  GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0,
  GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0,
  GET_ALL_THERAPY_TEMPLATES_LOADING_2_0,
  GET_ALL_THERAPY_TEMPLATES_RESET_2_0,
  GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0,
} = therapyPlanningAction;

function* getAllTherapyPlanningTemplates(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ALL_THERAPY_TEMPLATES_LOADING_2_0 });
    const response = yield call(therapyPlanningService.getAllTemplates, payload?.payload);
    if (response?.status === 200) {
      yield put({
        type: GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0,
        payload: response?.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0, payload: error });
  }
}

function* getAllTherapyPlanningTemplatesSaga() {
  yield takeEvery(GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0, getAllTherapyPlanningTemplates);
}

export default getAllTherapyPlanningTemplatesSaga;
